import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import moment from 'moment';
import {
  studentListFilters,
  LOCKED_FILTER_KEY,
  UNASSIGNED_FILTER_KEY,
} from './studentsListFilter';

const studentShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  username: PropTypes.string,
  avatar: PropTypes.string,
  active: PropTypes.bool,
});

const singleSubmission = PropTypes.shape({
  student: studentShape,
  submission: PropTypes.shape({
    status: PropTypes.string,
    submittedOn: PropTypes.string,
    evaluatedOn: PropTypes.string,
    returnedOn: PropTypes.string,
    response: PropTypes.shape({
      attachment: PropTypes.shape({
        fileName: PropTypes.string,
        path: PropTypes.string,
      }),
      comment: PropTypes.string,
      score: PropTypes.number,
    }),
  }),
});

export const AssignmentStudentListProps = {
  groupedSubmissions: PropTypes.shape({
    pendingSubmission: PropTypes.arrayOf(singleSubmission),
    submitted: PropTypes.arrayOf(singleSubmission),
    returned: PropTypes.arrayOf(singleSubmission),
    pendingEvaluation: PropTypes.arrayOf(singleSubmission),
    evaluated: PropTypes.arrayOf(singleSubmission),
  }).isRequired,
  unAssignedStudents: PropTypes.arrayOf(studentShape).isRequired,
  dueOn: PropTypes.string.isRequired,
  maxScore: PropTypes.number,
  maxStars: PropTypes.number,
  gradeable: PropTypes.bool.isRequired,
  attachmentRequired: PropTypes.bool.isRequired,
  commentRequired: PropTypes.bool.isRequired,
  onNavigateToStudent: PropTypes.func,
  onSubmissionsReturn: PropTypes.func,
  teamsData: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
      members: PropTypes.arrayOf(
        PropTypes.shape({
          learnerId: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
};

export const filterBySelectedTeam = (
  selectedFilter,
  selectedTeamMembersIds,
  students,
) =>
  selectedFilter === ''
    ? students
    : students.filter(({ student }) =>
        selectedTeamMembersIds.includes(student.id),
      );

export const selectedKeyToInputFilter = selectedKey => {
  if (
    selectedKey === studentListFilters[0].key ||
    selectedKey === 'Left the Class'
  )
    return undefined;

  if (selectedKey === 'Pending Submission') return { status: 'PENDING' };
  if (selectedKey === 'Pending Evaluation') return { status: 'SUBMITTED' };
  if (selectedKey === 'To Be Returned') return { status: 'EVALUATED' };
  if (selectedKey === 'Late Submissions') return { lateSubmission: true };
  if (
    selectedKey === LOCKED_FILTER_KEY ||
    selectedKey === UNASSIGNED_FILTER_KEY
  )
    return { unAssignedStudentsOnly: true };

  return { status: selectedKey.toUpperCase() };
};

export const sortGroupedSubmissionByStudent = groupedSubmission =>
  sortBy(groupedSubmission, ({ student }) => student.name);

export const formatDate = date => moment(date).format('MMM D, YYYY');
